import {useNavigate} from 'react-router'
import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Container} from '@freckle/educator-materials/ts/components/container'
import {Image} from '@freckle/educator-materials/ts/components/img'
import {H3, H4} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import {
  header,
  imageWrapper
} from '@freckle/school/ts/rostering/components/common/clean-up-row/clean-up-row.module.scss'
import {LearnMore} from '@freckle/school/ts/rostering/components/common/clean-up-row/learn-more'
import ConfirmButton from '@freckle/school/ts/rostering/components/common/confirm-button'
import DetailColumn from '@freckle/school/ts/rostering/components/common/detail-column'

type Props = {
  numSelfRosteredTeachers: number
  activeIdpsString: string
}

export function CleanUpSelfRosteredTeachers(props: Props) {
  const {t} = useSafeTranslation()
  const reactRouterHistory = useNavigate()
  const {numSelfRosteredTeachers, activeIdpsString} = props

  const manySelfRosteredTeachers = (
    <>
      <p>
        <strong>
          {t('CLEAN_UP_SELF_ROSTERED_MANY_NOT_SYNC', {
            numSelfRosteredTeachers,
            activeIdpsString
          })}
        </strong>
      </p>
      <p>{t('CLEAN_UP_SELF_ROSTERED_MANY_PARAGRAPH', {activeIdpsString})}</p>
      <div>
        <LearnMore>
          <DetailColumn>
            <SafeTrans
              i18nKey="CLEAN_UP_SELF_ROSTERED_LEARN_MORE_DETAIL_COL_1"
              values={{activeIdpsString}}
              components={{
                h4: <H4 />,
                ul: <ul />,
                li: <li />
              }}
            />
          </DetailColumn>
          <DetailColumn>
            <SafeTrans
              i18nKey="CLEAN_UP_SELF_ROSTERED_LEARN_MORE_DETAIL_COL_2"
              values={{activeIdpsString}}
              components={{
                h4: <H4 />,
                ul: <ul />,
                li: <li />
              }}
            />
          </DetailColumn>
        </LearnMore>
      </div>
    </>
  )

  const noSelfRosteredTeachers = (
    <>
      <p>
        <strong>{t('CLEAN_UP_SELF_ROSTERED_NO_TEACHERS', {activeIdpsString})}</strong>
      </p>
      <p>{t('CLEAN_UP_SELF_ROSTERED_NO_TEACHERS_TO_REMOVE')}</p>
    </>
  )

  const reviewSelfRosteredTeachers = () =>
    reactRouterHistory(Routes.rostering.removeSelfRosteredTeachers())

  return (
    <>
      <Container>
        <div className={header}>
          <Image
            className={imageWrapper}
            src={`${PATHS.imageAssetsUrl}/school/icons/bulk-unaffiliate.svg`}
            width="110"
          />
          <div>
            <H3>{t('CLEAN_UP_SELF_ROSTERED_HEADER_3')}</H3>
            {numSelfRosteredTeachers > 0 ? manySelfRosteredTeachers : noSelfRosteredTeachers}
          </div>
        </div>
        <ConfirmButton
          onConfirm={numSelfRosteredTeachers > 0 ? reviewSelfRosteredTeachers : undefined}
          style="secondary"
          text={t('CLEAN_UP_SELF_ROSTERED_CONFIRM_BUTTON')}
        />
      </Container>
    </>
  )
}
